module.exports = __webpack_public_path__ + "img/vip_disabled.9c6186d4.png";